import { sortDates } from "../sortDates";
import { getBookingDate } from "../getBookingDate";

export const formatRoomNightsChartData = (
  bookedBookings,
  cancelledBookings,
  dataMode
) => {
  const bookedByDate = bookedBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    const numberOfRooms = booking.rooms.reduce(
      (sum, room) => sum + room.numberOfRooms,
      0
    );
    acc[date] = (acc[date] || 0) + booking.totaldays * numberOfRooms;
    return acc;
  }, {});
  const cancelledByDate = cancelledBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    const numberOfRooms = booking.rooms.reduce(
      (sum, room) => sum + room.numberOfRooms,
      0
    );
    acc[date] = (acc[date] || 0) + booking.totaldays * numberOfRooms;
    return acc;
  }, {});

  const labels = sortDates([
    ...new Set([...Object.keys(bookedByDate), ...Object.keys(cancelledByDate)]),
  ]);
  const bookedData = labels.map((date) => Number(bookedByDate[date] || 0));
  const cancelledData = labels.map((date) =>
    Number(cancelledByDate[date] || 0)
  );

  return {
    labels,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(153, 102, 255, 0.6)",
        borderColor: "rgba(153, 102, 255, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };
};
